import * as Sentry from "@sentry/react";

import type { APIProjectResponse } from "@/data_source/models/APIProjectResponse";
import type { APIUserResponse } from "@/data_source/models/APIUserResponse";

const COMPANY_CONTEXT = "company";
const WORKSPACE_CONTEXT = "workspace";

function getUsername(user: APIUserResponse): string | undefined {
  const displayName = user.name?.trim();
  if (displayName) return displayName;

  const fullName = [user.first_name, user.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  return fullName || undefined;
}

export function clearSentryContext(): void {
  Sentry.setUser(null);
  Sentry.setContext(COMPANY_CONTEXT, null);
  Sentry.setContext(WORKSPACE_CONTEXT, null);
}

export function syncSentryContext(
  user?: APIUserResponse | null,
  workspace?: Partial<APIProjectResponse> | null
): void {
  if (!user) {
    clearSentryContext();
    return;
  }

  Sentry.setUser({
    id: String(user.id),
    email: user.email,
    username: getUsername(user)
  });

  const company = user.company;
  Sentry.setContext(
    COMPANY_CONTEXT,
    company?.id || company?.name
      ? {
          id: company.id,
          name: company.name
        }
      : null
  );

  Sentry.setContext(
    WORKSPACE_CONTEXT,
    workspace?.id || workspace?.name || workspace?.code
      ? {
          id: workspace.id,
          name: workspace.name,
          code: workspace.code
        }
      : null
  );
}
